import {Button, Col, Form, Row} from "react-bootstrap";
import Container from "react-bootstrap/Container";
import API from "../api/api"
import {useState} from "react";

function Signup() {
    const [error, setError] = useState("");
    const [goodUsername, setGoodUsername] = useState(true);
    const [goodEmail, setGoodEmail] = useState(true);

    async function handleSignup(event) {
        event.preventDefault();
        if (event.target.password.value !== event.target.passwordConfirmation.value) {
            setError("unmatched password");
            return
        }

        API.post("users/add-user", {
            email: event.target.email.value,
            firstname: event.target.firstname.value,
            lastname: event.target.lastname.value,
            username: event.target.username.value,
            password: event.target.password.value,
            birth_date: event.target.birthDate.value
        })
    }

    async function checkUsername(event) {
        if (event.target.value === "") {
            setGoodUsername(true);
            return;
        }
        API.get("users/check-username-exist?username=" + event.target.value).then(response => {
            setGoodUsername(!response.data);
        })
    }

    async function checkEmail(event) {
        if (event.target.value === "") {
            setGoodEmail(true);
            return;
        }
        API.get("users/check-email-exist?email=" + event.target.value).then(response => {
            setGoodEmail(!response.data);
        })
    }

    return (
        <div className="bg-gradient-dark text-white">
            <Container className="d-flex justify-content-center align-items-center p-5 flex-column">
                <p className="display-2 fw-bold text-white mb-5">Sign Up</p>
                <Form className="shadow p-5 rounded text-center fw-bolder"
                      style={{background: "rgba(255, 255, 255, 0.1)"}} onSubmit={handleSignup}>
                    <Form.Group className="mb-3" controlId="formGridUsername">
                        <Form.Label>Username</Form.Label>
                        <Form.Control required name="username" placeholder="username" onChange={checkUsername} />
                    </Form.Group>
                    {(!goodUsername) && (
                        <Form.Text className="text-danger">Username is not available</Form.Text>
                    )}

                    <Row className="mb-3">
                        <Form.Group as={Col} controlId="formGridFirstname">
                            <Form.Label>First Name</Form.Label>
                            <Form.Control required name="firstname" type="firstname" placeholder="first name"/>
                        </Form.Group>

                        <Form.Group as={Col} controlId="formGridLastname">
                            <Form.Label>Last Name</Form.Label>
                            <Form.Control required name="lastname" type="lastname" placeholder="last name"/>
                        </Form.Group>
                    </Row>

                    <Form.Group className="mb-3" controlId="formGridEmail">
                        <Form.Label>Email</Form.Label>
                        <Form.Control required onChange={checkEmail} name="email" type="email" placeholder="Email"/>
                    </Form.Group>
                    {(!goodEmail) && (
                        <Form.Text className="text-danger">Email is not available</Form.Text>
                    )}


                    <Form.Group className="mb-3" controlId="formGridPassword2">
                        <Form.Label>Birth Date</Form.Label>
                        <Form.Control required name="birthDate" type="date" placeholder="Birth Date"/>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formGridPassword">
                        <Form.Label>Password</Form.Label>
                        <Form.Control required name="password" type="password" placeholder="Password"/>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formGridPasswordConfirmation">
                        <Form.Label>Password Confirmation</Form.Label>
                        <Form.Control required name="passwordConfirmation" type="password" placeholder="Password"/>
                        {error === "unmatched password" && (
                            <Form.Text className="text-danger">Your password does not match</Form.Text>
                        )}
                    </Form.Group>

                    <Button variant="primary" className="bg-warning w-100 fw-bold" type="submit">
                        Signup
                    </Button>
                </Form>
            </Container>

        </div>
    );
}

export default Signup;